<div 
    [ngClass]="{ 
        'g2': type === NETWORK_TYPE.G2,
        'g4': type === NETWORK_TYPE.G4 || type === NETWORK_TYPE.G5
    }"
    class="network"
>
    <span>
        {{ type }}
    </span>
</div>
